module.exports = __webpack_public_path__ + "img/50.9f432822.png";